import { buttonBaseClasses, buttonClasses, Theme } from '@mui/material';
import { AiToolCallState } from '@treadinc/horizon-api-spec';

import { TreadAgentToolCallState } from '~tread-agent/types';

export const SUBTLE_CARD_BOX_SHADOW = '0 1px 2px rgba(0, 0, 0, 0.04)';

// SmallButton pins its height through a `&.MuiButtonBase-root` rule, so a plain `sx` height loses
// on specificity and silently does nothing.
export const COMPACT_ACTION_BUTTON_SX = {
  [`&.${buttonBaseClasses.root}`]: {
    fontSize: '11px',
    height: 24,
    px: 1,
    [`& .${buttonClasses.startIcon}`]: { ml: -0.25, mr: 0.25 },
  },
};

export function terminalStatusColor(state: TreadAgentToolCallState, theme: Theme) {
  if (state === AiToolCallState.APPLIED) {
    return theme.brandV2.colors.treadGreen;
  }

  if (state === AiToolCallState.FAILED) {
    return theme.brandV2.colors.treadRed;
  }

  return theme.brandV2.colors.treadGray3;
}
